import React from 'react';
import { useTabs } from '../Tabs';

const TabContent = () => {
  const tabs = useTabs();
  return <>{tabs.getActiveContent()}</>;
};

export default TabContent;
